import { combineReducers, configureStore } from '@reduxjs/toolkit';
import sessionStatus from './sessionStatus';
import setQuestions from './setQuestions';

const rootReducer = combineReducers({
    questions: setQuestions,
    session: sessionStatus,
});

export const store = configureStore({
    reducer: rootReducer,
});
